// extracted by mini-css-extract-plugin
export default {"iframe":"LegalDocument-module__iframe___HGx8m"};